import Vue from 'vue'
import Router from 'vue-router'
import MetsanomistajaIntro from './components/metsanomistaja/Intro.vue';
import MetsankayttajaIntro from './components/metsankayttaja/Intro.vue';
import MetsanomistajaQuestion from './components/metsanomistaja/Question.vue';
import MetsankayttajaQuestion from './components/metsankayttaja/Question.vue';
import MetsanomistajaResult from './components/metsanomistaja/Results.vue';
import MetsankayttajaResult from './components/metsankayttaja/Results.vue';
import TestMetsankayttajaResult from './tests/metsankayttaja/TestMetsankayttajaResult.vue';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/metsanomistaja',
    },
    {
      path: '/metsanomistaja',
      name: 'metsanomistaja',
      component: MetsanomistajaIntro
    },
    {
      path: '/metsanomistaja/kysymykset',
      name: 'metsanomistaja.kysymys',
      component: MetsanomistajaQuestion
    },
    {
      path: '/metsanomistaja/tulos',
      name: 'metsanomistaja.tulos',
      component: MetsanomistajaResult
    },
    {
      path: '/metsankayttaja',
      name: 'metsankayttaja',
      component: MetsankayttajaIntro
    },
    {
      path: '/metsankayttaja/kysymys/:q',
      name: 'metsankayttaja.kysymys',
      component: MetsankayttajaQuestion
    },
    {
      path: '/metsankayttaja/tulos',
      name: 'metsankayttaja.tulos',
      component: MetsankayttajaResult
    },
    {
      path: '/testi/metsankayttaja/tulos',
      name: 'testi.metsankayttaja.tulos',
      component: TestMetsankayttajaResult
    }
  ]
})
